import { apiRequest } from "../client";
import type { CompanyTheme } from "./types";

/**
 * Get the current company theme
 */
export const getCompanyTheme = async (): Promise<CompanyTheme | null> => {
  try {
    return await apiRequest<CompanyTheme>({
      method: "GET",
      url: "/company-theme",
    });
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    console.error("Failed to load company theme:", error);
    return null;
  }
};

/**
 * Save/update the company theme
 */
export const saveCompanyTheme = async (theme: CompanyTheme): Promise<CompanyTheme> => {
  return apiRequest<CompanyTheme>({
    method: "PUT",
    url: "/company-theme",
    data: theme,
  });
};

/**
 * Delete the company theme
 */
export const deleteCompanyTheme = async (): Promise<void> => {
  return apiRequest<void>({
    method: "DELETE",
    url: "/company-theme",
  });
};

